import { Box, VStack, HStack, Link, Text } from "@chakra-ui/react";
import {
  faCalendar,
  faClock,
  faLocationDot,
  faUserGroup,
  faListCheck,
  faLink,
  faWallet,
  faCircleUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useTranslation } from "react-i18next";
import { IEventDetail } from "../../model";

interface IProps {
  data: IEventDetail;
}

export const Information = ({ data }: IProps) => {
  const { t } = useTranslation();

  const startTimeString = data?.startTime || "";
  const endTimeString = data?.endTime || "";
  const [startHour, startMinute] = startTimeString.split(":").map(Number);
  const [endHour, endMinute] = endTimeString.split(":").map(Number);
  const timeDifferenceInMinutes =
    endHour * 60 + endMinute - (startHour * 60 + startMinute);

  return (
    <Box
      p="30px 0px"
      display="flex"
      flexDirection={{ base: "column", md: "row" }}
      gap={{ base: "30px", md: "100px" }}
      borderBottom="1px solid #d4d4d4"
    >
      <VStack align="start" spacing="20px">
        <HStack spacing="15px">
          <FontAwesomeIcon fontSize="23px" icon={faClock} />
          <Text fontSize="20px">
            {data?.duration
                ? `${data?.startDate} ${data?.startTime || ""} - ${data.duration} ${t("Minutes")}`
                : data?.startDate === data?.endDate || !data?.endDate
                    ? `${data?.startDate} ${data?.startTime || ""}`
                    : `${data?.startDate} ${data?.startTime || ""} - ${data?.endDate} ${data?.endTime || ""}`
            }
          </Text>
        </HStack>



        <HStack spacing="15px">
          <FontAwesomeIcon fontSize="23px" icon={faLocationDot} />
          <Link
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
              data?.address || "Baku, Azerbaijan"
            )}`}
            isExternal
            color="#6AF6FF"
            fontSize="20px"
          >
            {data?.address || "Baku, Azerbaijan"}
          </Link>
        </HStack>

        <HStack spacing="15px">
          <FontAwesomeIcon fontSize="23px" icon={faUserGroup} />
          <Text fontSize="20px">
            Min: {data?.minAttendees} / Max: {data?.maxAttendees}
          </Text>
        </HStack>
      </VStack>

      <VStack align="start" spacing="20px">
        {!!data?.listOfCategories?.length && (
          <HStack spacing="15px">
            <FontAwesomeIcon fontSize="23px" icon={faListCheck} />
            <Text fontSize="20px">
              {data?.listOfCategories?.map((item) => item?.name).join(", ")}
            </Text>
          </HStack>
        )}
        {data?.websiteUrl && (
            <HStack spacing="15px">
              <FontAwesomeIcon fontSize="23px" icon={faLink} />
              <Link href={data.websiteUrl} isExternal color="#6AF6FF">
                <Text fontSize="20px">{data.websiteUrl}</Text>
              </Link>
            </HStack>
        )}
        {data?.linkUrl && (
            <HStack spacing="15px">
              <FontAwesomeIcon fontSize="23px" icon={faLink} />
              <Link href={data.linkUrl} isExternal color="#6AF6FF">
                <Text fontSize="20px">{data.linkUrl}</Text>
              </Link>
            </HStack>
        )}
        {data?.paymentLink && (
            <HStack spacing="15px">
              <FontAwesomeIcon fontSize="23px" icon={faWallet} />
              <Link
                  href={data.paymentLink}
                  isExternal
                  color="#6AF6FF"
                  position="relative"
                  _hover={{ textDecoration: "none" }} // Remove underline on hover
              >
                <Text fontSize="20px">{data.paymentLink}</Text>
                <Text
                    fontSize="16px"
                    position="absolute"
                    left="0"
                    top="100%"
                    mt="2px"
                    color="gray.400"
                    visibility="hidden"
                    opacity="0"
                    transition="visibility 0s, opacity 0.2s linear"
                    _groupHover={{ visibility: "visible", opacity: "1" }}
                >
                  See More
                </Text>
              </Link>
            </HStack>
        )}

        {data.ticketType !== "OTHER" && (
            <HStack spacing="15px">
              <FontAwesomeIcon fontSize="23px" icon={faWallet} />
              <Text fontSize="20px">
                {data.ticketType === "PAID"
                    ? `${data.ticketCost} ₼`
                    : data.ticketType === "FREE"
                        ? t("FREE")
                        : t("OTHER")}
              </Text>
            </HStack>
        )}
        <HStack spacing="15px">
          <FontAwesomeIcon fontSize="23px" icon={faCircleUser} />
          <Text fontSize="20px">
            {t("Hosted hosted")}{" "}
            <Link color="#6AF6FF">{data?.userView?.userName}</Link>
          </Text>
        </HStack>
      </VStack>
    </Box>
  );
};
